import React from 'react'
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import aboutBanner from '../assests/img/about-banner.jpg';
import sponsershippdf from '../assests/img/Jaipur Branding Prospactus_2025.pdf';
import { Helmet } from 'react-helmet-async';

function Sponsership() {
return (
    <div >
      <Helmet>
                                        <title>ISJS 2025 Sponsorship Opportunities – Partner with India’s Leading Jewellery Show</title>
                                        <meta
                                          name="description"
                                          content="Partner with ISJS 2025 as a sponsor and gain brand visibility at India’s premier jewellery & gemstones trade show attended by global buyers."
                                        />
                                        <meta
                              name="keywords"
                              content=" ISJS sponsorship, jewellery show sponsor India, gemstone exhibition partner, ISJS 2025 sponsor benefits, trade fair India branding"
                            />
                                      </Helmet>
    
    <Header/>
    {/* <Showlist/> */}
    <div className='container'>
        <div className='about-banner'>
            <img src={aboutBanner} alt=""/>
        </div>
    </div>
    
    <div className='container main-contant'>
      <div className='inner-page-container'>
        <h1 className='page-title'>Sponsorship</h1>
        <div className='row'>

        
        <div className='col-md-6'>
        <p>Dear Valued ISJS Exhibitors,</p>
        <p>We are all set for our upcoming Edition of India Silver Jewellery Show from 8 to 10 Nov 2025 at JECC, Sitapura, Jaipur.</p>
        <p>To help boost your brand, ISJS is proud to offer 'Sponsorship Opportunities' to the exhibitors during the Exhibition.</p>
        <p>These opportunities will be available only for the limited number of participants, stay tuned to grab the sponsorship opportunity.</p>
       
        </div>

        <div className='col-md-6 sponser-detail-box'>
        For details, kindly refer to the attached file<br/>
        <a href={sponsershippdf} className='btn btn-primary'>Download Now</a>
        <h3> For more details, please get in touch with:</h3>
        <p>Name: Manish Singh</p>
        <p>Mobile No: +91-99904 88666</p>
       
        
       
        </div>
        </div>
      </div>
    
    </div>
    <Footer/>
     </div>
    )
}

export default  Sponsership;
